// apps/web/src/pages/author/sections/IdentityFields.tsx
//
// Phase 8 Plan 07 Task 3 — IdentityFields (authr-01).
//
// First concrete form section. Renders the recipe identity fields per
// UI-SPEC §"Form sections (left panel)" Identity row (lines 318, 327-328):
//   - title (required, min 1 char per RecipeDefinitionV1 schema)
//   - description (optional)
//
// FORMSTATE DISCIPLINE: this section reads useFormContext().control only.
// No useFormState() / no formState.* reads — per the toolbar-only discipline
// established in EditorToolbar.tsx file header.
//
// The data-field-path attributes on each FormItem outer div enable the
// preview-pane's "Jump to field" affordance (UI-SPEC §"Preview-pane →
// form-panel jump-to-field affordance" line 668). Plan 10's PreviewPane
// queries these attributes for scrollIntoView.

import type { RecipeDefinitionV1 } from "@the-recipe-spread/shared";
import { useFormContext } from "react-hook-form";
import { Fieldset } from "@/components/ui/fieldset";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export function IdentityFields(): React.ReactElement {
  const { control } = useFormContext<RecipeDefinitionV1>();
  return (
    <Fieldset legend="IDENTITY">
      <FormField
        control={control}
        name="title"
        render={({ field }) => (
          <FormItem data-field-path="title">
            <FormLabel>Title</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormDescription>Required. Shown as the recipe's title.</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="description"
        render={({ field }) => (
          <FormItem data-field-path="description">
            <FormLabel>Description</FormLabel>
            <FormControl>
              <Textarea {...field} value={field.value ?? ""} />
            </FormControl>
            <FormDescription>Optional. Markdown not supported in v1.</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </Fieldset>
  );
}
